import { AxiosRequestConfig } from "axios";
import ApiService from "../utils/api-services";

class CategoryService extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: `${process.env.REACT_APP_BASE_LOCALY_URL}/api`,
      ...config,
    });
  }

  public UploadAttachment = async (body: any): Promise<any> => {
    return await this.post("/services/app/Attachment/Upload", body);
  };
}

export const UploadAttachment = new CategoryService();
